import React, {useState} from 'react';
import {Col, Row} from 'reactstrap';

import {ButtonNew} from "../../../components/buttons/buttonsActions";
import AwardForm from "./_form";
import AwardList from "./_list";

export default function Award(){

    const [showList, setShowList] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [item, setItem] = useState();

    const setForm = (editModeP, data, showListP) => {
        setEditMode(editModeP ? editModeP : editMode);
        setShowList(showListP ? showListP : !showList);
        setItem(data);
    }

    const updateItem = (item) => {
        setItem(item)
    }

    return (
        <div>
            {/*--------------------------------------------------------------------------------*/}
            {/* Header*/}
            {/*--------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            !showList &&
                            <div className="ml-auto paddingAdd">
                                <ButtonNew onClick={setForm}/>
                            </div>
                        }
                    </div>
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Listado*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {!showList && <AwardList setForm={setForm}/>}
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Formulario*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {showList && <AwardForm
                        setForm={setForm}
                        updateItem={updateItem}
                        item={item}
                        editMode={editMode}
                    /> }
                </Col>
            </Row>
        </div>
    );
}
